"use client";

import { c as _c } from "react/compiler-runtime";
import { Radio, RadioGroup } from "@navikt/ds-react";
import type { ReactNode } from "react";
import { logAnalyticsEvent } from "@/common/analytics/logAnalyticsEvent";
import { useFieldContext } from "../hooks/form-context";
interface Props {
  label: string;
  description?: ReactNode;
  isRequired: boolean;
  options: {
    value: string;
    label: string;
    description?: string;
  }[];
  isChangeDisabled?: boolean;
  isReadOnly?: boolean;
  className?: string;
}
export default function FormRadioGroup(t0) {
  const $ = _c(20);
  const {
    label,
    description,
    isRequired,
    options,
    isChangeDisabled: t1,
    isReadOnly: t2,
    className
  } = t0;
  const isChangeDisabled = t1 === undefined ? false : t1;
  const isReadOnly = t2 === undefined ? false : t2;
  const field = useFieldContext();
  let t3;
  if ($[0] !== field.state.meta.errors) {
    t3 = field.state.meta.errors.map(_temp).join(", ");
    $[0] = field.state.meta.errors;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const errorMessages = t3;
  let handleChange;
  if ($[2] !== field || $[3] !== label || $[4] !== options.length) {
    handleChange = value => {
      logAnalyticsRadioValgEndret(value);
      field.setValue(value);
    };
    function logAnalyticsRadioValgEndret(value_0) {
      logAnalyticsEvent({
        name: "radio valg endret",
        properties: {
          komponentId: label,
          valgtAlternativ: value_0,
          antallAlternativer: options.length
        }
      });
    }
    $[2] = field;
    $[3] = label;
    $[4] = options.length;
    $[5] = handleChange;
  } else {
    handleChange = $[5];
  }
  const t4 = field.name;
  const t5 = field.state.value;
  const t6 = !isChangeDisabled ? handleChange : undefined;
  const t7 = field.handleBlur;
  let t8;
  if ($[6] !== options) {
    t8 = options.map(_temp2);
    $[6] = options;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== className || $[9] !== description || $[10] !== errorMessages || $[11] !== field.handleBlur || $[12] !== field.name || $[13] !== field.state.value || $[14] !== isReadOnly || $[15] !== isRequired || $[16] !== label || $[17] !== t6 || $[18] !== t8) {
    t9 = <RadioGroup id={t4} legend={label} description={description} error={errorMessages} value={t5} onChange={t6} onBlur={t7} className={className} disabled={isReadOnly} aria-required={isRequired}>{t8}</RadioGroup>;
    $[8] = className;
    $[9] = description;
    $[10] = errorMessages;
    $[11] = field.handleBlur;
    $[12] = field.name;
    $[13] = field.state.value;
    $[14] = isReadOnly;
    $[15] = isRequired;
    $[16] = label;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
function _temp2(option) {
  return <Radio key={option.value} value={option.value} description={option.description}>{option.label}</Radio>;
}
function _temp(err) {
  return err?.message;
}